
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<SkeletonDiv>({})
export default class SkeletonDiv extends Vue {
    @Prop({ type: String, required: false })
    readonly width!: string

    @Prop({ type: String, required: false })
    readonly height!: string

    get style() {
        return `width: ${this.width ? this.width : '100%'};
                height: ${this.height ? this.height : '90%'};`
    }
}
